/*
 * @Date: 2022-09-06 14:55:39
 * @LastEditors: OBKoro1
 * @LastEditTime: 2022-11-01 12:03:31
 * @FilePath: \ngtc-traceability-admin\src\app\interceptor\api.interceptor.ts
 */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { catchError, filter, map, Observable, throwError, } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';
import { SecurityService } from '../security/security.service';


@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    constructor(public securityService:SecurityService,public message: NzMessageService,public router:Router) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            filter(event => event instanceof HttpResponse)
            , map((response: any) => {
                // if (response && response.body) {
                //     if(response.body.hasOwnProperty("Success") && !response.body.Success) {
                //         this.message.create('error', response.body.Message || '网络请求返回失败');
                //     }
                // } 
                return response;
            }),
            catchError(
                (
                    httpErrorResponse: HttpErrorResponse,
                    _: Observable<HttpEvent<any>>
                ) => {
                    if (httpErrorResponse.status === HttpStatusCode.Unauthorized) {
                        this.securityService.logout()
                        this.router.navigate(['passport','login'])
                        this.message.error('访问未授权，请重新登录！');
                        
                    }
                    return throwError(httpErrorResponse);
                }
            )
        )
    }
}